import React from 'react'

import './Spinner.css'

export function Spinner({ active = false, expand = true, opacity = 0.8 }) {
    if (!active) return null
    return (
        <div className={`Spinner-container ${expand ? 'expand' : ''}`} style={{ opacity: expand ? opacity : 1 }}>
            <div className="Spinner-dots">
                <div className="Spinner-bounce1" />
                <div className="Spinner-bounce2" />
                <div className="Spinner-bounce3" />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/components/Spinner/Spinner.js